export const jewelleryFindingsLevelThree = [
    {
        "name": "Lobster",
        "categoryId": "lobster",
        "parentCategoryName": "Clasps",
        "parentCategoryId": "clasps",
        "level": 3
    },
    {
        "name": "Barrel Clasps",
        "categoryId": "barrel_clasps",
        "parentCategoryName": "Clasps",
        "parentCategoryId": "clasps",
        "level": 3
    },
    {
        "name": "Open Mouth",
        "categoryId": "open_mouth",
        "parentCategoryName": "Jump Ring",
        "parentCategoryId": "jump_ring",
        "level": 3
    },
    {
        "name": "Close Mouth",
        "categoryId": "close_mouth",
        "parentCategoryName": "Jump Ring",
        "parentCategoryId": "jump_ring",
        "level": 3
    },
    {
        "name": "Earring Hooks",
        "categoryId": "earring_hooks",
        "parentCategoryName": "Earrings Making Parts",
        "parentCategoryId": "earrings_making_parts",
        "level": 3
    },
    {
        "name": "Ball Pin",
        "categoryId": "ball_pin",
        "parentCategoryName": "Eye & Head Pins",
        "parentCategoryId": "eye_n_head_pins",
        "level": 3
    },
    {
        "name": "Head Pin",
        "categoryId": "head_pin",
        "parentCategoryName": "Eye & Head Pins",
        "parentCategoryId": "eye_n_head_pins",
        "level": 3
    },
    {
        "name": "Eye Pin",
        "categoryId": "eye_pin",
        "parentCategoryName": "Eye & Head Pins",
        "parentCategoryId": "eye_n_head_pins",
        "level": 3
    }
]